import React, { Component } from 'react';
import styles from './styles.scss';
import Tooltip from 'components/util/tooltip';
import Highlighter from 'react-highlight-words';

class InterpolateTooltip extends Component {
  render() {
    return (
      <Tooltip text="This is a dynamic value in the app. Ensure that you retain this in your translation. Ex: &quot;Me llamo, {example}.&quot;">
        <span className={styles.highlight}>{this.props.children}</span>
      </Tooltip>
    );
  }
}

export default class InterpolateHightlighter extends Component {
  render() {
    const { interpolators, value } = this.props;
    if (!interpolators || !interpolators.length) {
      return value;
    }
    return (
      <Highlighter
        searchWords={interpolators}
        autoEscape={true}
        textToHighlight={value}
        highlightTag={InterpolateTooltip}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/partnerDashboard/interpolateHighlighter/index.js